// reducers/qualificationReducer.js
export const qualificationReducer = (
  state = { qualifications: [], pending: [], rejected: [] },
  action,
) => {
  switch (action.type) {
    case "ALL_QUALIFICATIONS_REQUEST":
    case "PENDING_QUALIFICATIONS_REQUEST":
    case "CREATE_QUALIFICATION_REQUEST":
    case "UPDATE_QUALIFICATION_REQUEST":
    case "DELETE_QUALIFICATION_REQUEST":
      return { ...state, loading: true };

    case "ALL_QUALIFICATIONS_SUCCESS":
      return { ...state, loading: false, qualifications: action.payload || [] };

    case "PENDING_QUALIFICATIONS_SUCCESS":
      return { ...state, loading: false, pending: action.payload || [] };

    case "REJECTED_QUALIFICATIONS_SUCCESS":
      return { ...state, rejected: action.payload || [] };

    case "CREATE_QUALIFICATION_SUCCESS":
      return {
        ...state,
        loading: false,
        success: true,
        qualifications: [...state.qualifications, action.payload],
      };

    // A new value typed on the Add Staff/Student form — goes to "pending".
    case "SUGGEST_QUALIFICATION_SUCCESS":
      return { ...state, success: true };

    case "APPROVE_QUALIFICATION_SUCCESS":
      return {
        ...state,
        pending: state.pending.filter((d) => d.id !== action.payload.id),
        qualifications: [...state.qualifications, action.payload].sort((a, b) =>
          a.name.localeCompare(b.name),
        ),
      };

    case "REJECT_QUALIFICATION_SUCCESS":
      return {
        ...state,
        pending: state.pending.filter((d) => d.id !== action.payload.id),
        rejected: [...state.rejected, action.payload],
      };

    case "RESUBMIT_QUALIFICATION_SUCCESS":
      return {
        ...state,
        rejected: state.rejected.filter((d) => d.id !== action.payload.id),
        pending: [...state.pending, action.payload],
      };

    case "UPDATE_QUALIFICATION_SUCCESS":
      return {
        ...state,
        loading: false,
        success: true,
        qualifications: state.qualifications.map((d) =>
          d.id === action.payload.id ? action.payload : d,
        ),
      };

    case "DELETE_QUALIFICATION_SUCCESS":
      return {
        ...state,
        loading: false,
        success: true,
        qualifications: state.qualifications.filter(
          (d) => d.id !== action.payload,
        ),
        pending: state.pending.filter((d) => d.id !== action.payload),
        rejected: state.rejected.filter((d) => d.id !== action.payload),
      };

    case "ALL_QUALIFICATIONS_FAIL":
    case "PENDING_QUALIFICATIONS_FAIL":
    case "REJECTED_QUALIFICATIONS_FAIL":
    case "CREATE_QUALIFICATION_FAIL":
    case "SUGGEST_QUALIFICATION_FAIL":
    case "APPROVE_QUALIFICATION_FAIL":
    case "REJECT_QUALIFICATION_FAIL":
    case "RESUBMIT_QUALIFICATION_FAIL":
    case "UPDATE_QUALIFICATION_FAIL":
    case "DELETE_QUALIFICATION_FAIL":
      return { ...state, loading: false, error: action.payload };

    case "CLEAR_ERRORS":
      return { ...state, error: null, success: false };

    default:
      return state;
  }
};
